import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { HorizontalSeparator } from '@myplay/ui';

const NavigationItem = ({ item })=> {
  return (
    <NavLink 
      to={item.path} 
      className="navigation-item"
      activeClassName="navigation-item--active"
    >
      <span className="navigation-item__text">{item.title.toUpperCase()}</span>
      <HorizontalSeparator />
    </NavLink>
  );
};

NavigationItem.propTypes = {
  isSelected: PropTypes.bool,
  item: PropTypes.object, 
  onClick: PropTypes.func
};

NavigationItem.defaultProps = {
  isSelected: false, 
  item: {}, 
  onClick: ()=> {}
};

export default NavigationItem;